import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { Collection } from 'src/app/models/collection.interface';
import { ConversationHistory } from 'src/app/models/conversations.interface';
import { ConversationsService } from 'src/app/services/conversations.service';
import { LocatedTimePipe } from '../../pipes/located-time/located-time.pipe';

@Component({
  selector: 'app-previous-discussions-modal',
  standalone: true,
  imports: [MatIconModule, MatDividerModule, MatFormFieldModule, CommonModule, LocatedTimePipe, MatDialogTitle],
  templateUrl: './previous-discussions-modal.component.html',
  styleUrl: './previous-discussions-modal.component.scss'
})
export class PreviousDiscussionsModalComponent implements OnInit {
  history: ConversationHistory[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      collection: Collection;
      selected_collections_id: string[];
    },
    public dialogRef: MatDialogRef<PreviousDiscussionsModalComponent>,
    private conversationsService: ConversationsService
  ) {}
  ngOnInit() {
    // TODO: Use ngrx
    this.conversationsService
      .loadConversations(this.data.collection.collection_id, this.data.selected_collections_id)
      .subscribe((response: ConversationHistory[]) => {
        this.history = response.sort((a, b) => {
          // Latest discussions come first
          return a.latest_prompt_time < b.latest_prompt_time ? 1 : -1;
        });
      });
  }

  selectConversation(session: ConversationHistory) {
    this.dialogRef.close(session);
  }

  protected readonly Intl = Intl;
  protected readonly navigator = navigator;
}
